<h3>{{'change.createSnr.new' | translate}}</h3>

<div class="ps-flex-container-col">
  <mat-form-field>
    <input matInput placeholder="{{'change.createSnr.index' | translate}}" [(ngModel)]="index"/>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="{{'change.createSnr.name' | translate}}" [(ngModel)]="name"/>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="{{'change.createSnr.description' | translate}}" [(ngModel)]="description"/>
  </mat-form-field>

  <div>
    <button mat-button (click)="cancel()">{{'change.createSnr.discard' | translate}}</button>
    <button mat-button (click)="save()">{{'change.createSnr.save' | translate}}</button>
  </div>
</div>
